import React from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { ROUTE_ADMIN_MANAGE } from "../../../../../config/routes";
import { Row, Col, Button } from "reactstrap";
import { GroupDetailsTable } from "./view/GroupDetailsTable";
import { ACL } from '../../../../../config/constants';

function GroupDetailsTab(props) {
  const { group, toggleEditMode } = props;

  return (
    <div className="admin-group-detail-section admin-group-detail-section--details">
      <div className="admin-group-detail-table">
        <GroupDetailsTable group={group}/>
      </div>
        <Row className="admin-group-detail-section__actions mt-2 text-right justify-content-md-end">
          <Col lg="auto" className="mb-2 mb-xl-0">
            {ACL.ADMIN.GROUPS.EDIT.hasAccess() && group && group.id && <Button
              color="primary"
              className="btn-warning"
              type="button"
              onClick={() => {
                toggleEditMode( "group", true );
              }}
            >
              <FormattedMessage id="button.edit"/>
            </Button>}
            <Link className="btn btn-secondary" to={ROUTE_ADMIN_MANAGE}>
              <FormattedMessage id="messages.go_back"/>
            </Link>
          </Col>
        </Row>
    </div>
  );
}

export { GroupDetailsTab };
